export const types = {
  SET_ORGANIZATION_PERFORMANCE_STATS: 'SET_ORGANIZATION_PERFORMANCE_STATS',

};
